<template>
  <b-modal
    id="consultInvoiceReceivedModal"
    no-close-on-backdrop
    hide-footer
    size="lg"
    centered
    @hidden="onHideModal"
  >
    <template #modal-title>
      <p class="h4">
        {{ modalTitle }}
      </p>
    </template>

    <e-spinner v-if="loadingModal" />

    <b-row v-else>
      <b-col md="3">
        <FormulateInput
          id="consult_modal-return_code"
          v-model="nfeDetail.returnCode"
          type="label"
          :label="$t('Código de retorno')"
        />
      </b-col>
      <b-col md="9">
        <FormulateInput
          id="consult_modal-return_message"
          v-model="nfeDetail.returnMessage"
          type="label"
          :label="$t('Mensagem de retorno')"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { BModal, BRow, BCol } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import alerts from '@/mixins/alerts'
import ESpinner from '@/views/components/ESpinner.vue'

const getInitialState = () => ({
  modalTitle: '',
  loadingModal: false,
  invoiceStatus: null,
  nfeDetail: {
    returnCode: null,
    returnMessage: '',
    invoiceCancelled: false,
  },
})

export default {
  components: { BModal, BRow, BCol, ESpinner },

  mixins: [alerts],

  props: {},

  data() {
    return {
      ...getInitialState(),
    }
  },

  computed: {},

  methods: {
    ...mapActions('pages/invoice/invoiceReceived', { stconsultInvoiceReceived: 'consultInvoiceReceived' }),

    async show(id, invoiceStatus = null) {
      if (!id) return

      Object.assign(this, getInitialState())
      this.modalTitle = this.$t('Consulta da Nota Fiscal')
      this.loadingModal = true
      this.invoiceStatus = invoiceStatus
      this.$bvModal.show('consultInvoiceReceivedModal')

      try {
        const response = await this.stconsultInvoiceReceived({
          invoiceId: id,
        })

        this.nfeDetail = {
          returnCode: response?.returnCode ?? null,
          returnMessage: response?.returnMessage ?? '',
          invoiceCancelled: response?.invoiceCancelled ?? false,
        }
        
        if (this.nfeDetail.invoiceCancelled && this.invoiceStatus === 'Processed') {
          this.showWarning({ message: this.$t(
            'A nota fiscal foi cancelada pelo fornecedor! <br> É necessário reverter a manifestação da nota.'
          )})
        }
      } catch (error) {
        this.showError({ error })
        this.$bvModal.hide('consultInvoiceReceivedModal')
      } finally {
        this.loadingModal = false
      }
    },
    onHideModal() {
      Object.assign(this, getInitialState())
    },
  },
}
</script>

<style lang="scss" scoped></style>